import React from 'react';
import PropTypes from 'prop-types';

import SrFooterButton from 'client/components/SrFooterButton/SrFooterButton';
import SrStaticFooter from 'client/components/SrStaticFooter';

const SrPartnerApprovalControl = ({ isBusy, isValid, editingStep, onNext }) => {
  const buttonText = isBusy ? 'Please wait...' : editingStep ? 'Save' : 'Next';

  return (
    <SrStaticFooter>
      <span />
      <SrFooterButton hasBoxShadow={isValid} disabled={isBusy} type="button" onClick={onNext}>
        {buttonText}
      </SrFooterButton>
    </SrStaticFooter>
  );
};

SrPartnerApprovalControl.propTypes = {
  isBusy: PropTypes.bool,
  isValid: PropTypes.bool.isRequired,
  onNext: PropTypes.func.isRequired,
};

SrPartnerApprovalControl.displayName = 'SrPartnerApprovalControl';

export default SrPartnerApprovalControl;
